export const PAGE_ACCESS_HIDDEN = 0;
export const PAGE_ACCESS_FULL = 15;

export function setSidebarPin({
  links = [],
  sidebarLinks = [],
  linkId,
  pinned,
}) {
  const nextSidebar = (sidebarLinks ?? []).filter(
    (entry) => entry?.link !== linkId
  );
  if (pinned) {
    nextSidebar.push({ link: linkId });
  }
  return { links, sidebarLinks: nextSidebar };
}

export function isSidebarPinned(sidebarLinks, linkId) {
  return (sidebarLinks ?? []).some((entry) => entry?.link === linkId);
}

export function setAllSettingPagesActive({
  links = [],
  sidebarLinks = [],
  linkIds = [],
}) {
  const idSet = new Set(linkIds);
  const kept = (sidebarLinks ?? []).filter((entry) => !idSet.has(entry?.link));
  return {
    links,
    sidebarLinks: [...kept, ...linkIds.map((linkId) => ({ link: linkId }))],
  };
}

export function clearSettingPagePins({
  links = [],
  sidebarLinks = [],
  linkIds = [],
}) {
  const idSet = new Set(linkIds);
  return {
    links,
    sidebarLinks: (sidebarLinks ?? []).filter((entry) => !idSet.has(entry?.link)),
  };
}

export function areAllSettingPagesActive(sidebarLinks, linkIds) {
  if (!linkIds?.length) return true;
  return linkIds.every((linkId) => isSidebarPinned(sidebarLinks, linkId));
}
